import React from "react";
import StarSvg from "./Star.svg"

import { StarContainer } from "./style";


export const Star = ({ top, left, size, parallax }) => {
  return (
    <StarContainer src={StarSvg} top={top} left={left} alt="a star" size={size} style={{transform: `translate3d(0,${parallax}vh,0)`}}/>
  );
};
